import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { parse } from 'query-string';

import useAuth from 'hooks/useAuth';
import usePrevious from 'hooks/usePrevious';
import { useCurrentUser } from 'api/user';

const useLoginModalRedirect = () => {
  const { isAuth } = useAuth();
  const history = useHistory();
  const { data: user } = useCurrentUser(!isAuth);
  const prevPathname = usePrevious(history?.location?.pathname);

  // Using this approach, because using useQueryParams was causing constant errors
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const urlParams = useMemo(() => parse(window.location.search), [
    window.location.search,
  ]);

  const isLoginModal = urlParams?.modal === 'login';
  const isUser = !!user;
  const username = isUser && user?.username;
  const email = isUser && user?.email;

  useEffect(() => {
    if (!isLoginModal && isAuth && isUser && !(username && email)) {
      window.location.href = '/?modal=login';
    }
  }, [isAuth, isUser, username, email, prevPathname, isLoginModal]);
};

export default useLoginModalRedirect;
